import React from 'react';
import PageTitle from '../components/common/pageTitle';
import { contractTypeData } from '../utils/fakeData/contractTypeData';
import ContractCard from './contract/contractCard';
import { ScrollRestoration } from 'react-router-dom';
import Title from '../components/common/title';

const Contract = () => {
  return (
    <>
      {/*<PageTitle link={"合約範本"} pageName={"合約範本"} />*/}
      <div className="team-area pages-style pt-100 pb-75">
        <div className="container">
          <Title sectionName={"所有合約"} sectionTitle={"一站提供所有常見契約類型"}/>

          <div className="row">
            {
              contractTypeData.map(({ id, contractType, description, social_media, src, url }) => {
                return (
                  <div key={id} className="col-lg-3 col-sm-6">
                    <ContractCard 
                      id={id} 
                      contractType={contractType} 
                      description={description} 
                      social_media={social_media} 
                      src={src} 
                      url={url}
                      style={"team-style"} 
                    />
                  </div>
                )
              })
            }
          </div>
        </div>
        <div className="bg-ellipse"></div>
      </div>
      <ScrollRestoration />
    </>
  )
}

export default Contract;